import { useState } from "react";
import { LayoutDashboard, BarChart, ChevronLeft, ChevronRight, Users } from "lucide-react";
import { Sidebar, SidebarContent, SidebarGroup, SidebarGroupContent, SidebarGroupLabel, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import { useNavigate } from "react-router-dom";
export const AdminSidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const navigate = useNavigate();
  return <Sidebar className={`h-screen border-r ${isCollapsed ? 'w-16' : 'w-64'}`}>
      <SidebarContent className="mx-0 my-[100px]">
        <div className="flex justify-end p-2">
          <button onClick={() => setIsCollapsed(!isCollapsed)} className="p-2 hover:bg-gray-100 rounded-lg">
            {isCollapsed ? <ChevronRight className="h-5 w-5" /> : <ChevronLeft className="h-5 w-5" />}
          </button>
        </div>
        <SidebarGroup>
          <SidebarGroupLabel>Admin Panel</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              <SidebarMenuItem>
                <SidebarMenuButton className="w-full flex items-center gap-2" onClick={() => navigate("/admin/dashboard")}>
                  <LayoutDashboard className="h-5 w-5" />
                  {!isCollapsed && <span>CRM</span>}
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton className="w-full flex items-center gap-2" onClick={() => navigate("/admin/dashboard?tab=analytics")}>
                  <BarChart className="h-5 w-5" />
                  {!isCollapsed && <span>Analytics</span>}
                </SidebarMenuButton>
              </SidebarMenuItem>
              <SidebarMenuItem>
                <SidebarMenuButton className="w-full flex items-center gap-2" onClick={() => navigate("/admin/manage-admins")}>
                  <Users className="h-5 w-5" />
                  {!isCollapsed && <span>Manage Admins</span>}
                </SidebarMenuButton>
              </SidebarMenuItem>
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>;
};